import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppDataResolver } from './app.resolver';
import { InterceptorService } from './interceptor.service';
import { AuthService } from './auth.service';

import { CoreModule } from './core/core.module';
import { CreditNoteModule } from './credit-note/credit-note.module';
import { WriteOffModule } from './write-off/write-off.module';
import { LateFeesModule } from './late-fees/late-fees.module';

import { AppComponent } from './app.component';


export function app_Init(authService: AuthService) {
  const url = new URL(window.location.href);
  const id = url.searchParams.get('id');
  const instance = url.searchParams.get('instance');
  const session =  url.searchParams.get('session');

  localStorage.setItem('type', url.pathname.slice(1));

  if (id) {
    localStorage.setItem('sfId', id);
  } else if ( url.pathname.slice(1) === 'writeoff') {
      localStorage.setItem('sfId', 'a1hq0000008lWA6');
  } else if (url.pathname.slice(1) === 'latefees') {
    localStorage.setItem('sfId', 'aFb2C0000004FKaSAM');
  } else {
    localStorage.setItem('sfId', 'aBq0z000000kFP3');
  }

  if (session === 'local') {
    return () => authService.localPromise(url.pathname.slice(1));
  } else {
    if (instance !== '' && session) {
      return () => authService.login(instance, session, url.pathname.slice(1));
    } else if (session) {
      return () => authService.login('zayo.my.salesforce.com', session, url.pathname.slice(1));
    } else {
      if (authService.isAuthenticated) {
        return () => true;
      } else {
        return () => false;
      }
    }
  }
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    CreditNoteModule,
    WriteOffModule,
    LateFeesModule
  ],
  providers: [
    AuthService,
    AppDataResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: app_Init,
      deps: [AuthService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
